import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import React from 'react';
import c from 'classnames';
import HeadlessRadioButton from '@wix/da-a11y/pkg/components/formControls/RadioButton';
import { IconSize } from '@wix/da-ds/pkg/Icons/IconWrap';
import DreamupIcon from '@wix/da-ds/pkg/Icons/32x32/DreamUp';
import s from './ImageRadioButton.scss';
/**
 * A radio button in the shape of a lozenge.
 *
 * This component has no theme, so be careful where you use it. Be sure to check contrast values
 * for accessibility compliance.
 */ const ImageRadioButton = (_param)=>{
    var { checked, className, children, backgroundImage, showDreamupLogo } = _param, rest = _object_without_properties(_param, [
        "checked",
        "className",
        "children",
        "backgroundImage",
        "showDreamupLogo"
    ]);
    return /*#__PURE__*/ React.createElement(HeadlessRadioButton, _object_spread({
        checked: checked,
        className: s['headless-wrapper']
    }, rest), /*#__PURE__*/ React.createElement("div", {
        className: c(s['root'], checked && s['selected'], className),
        style: {
            backgroundImage
        }
    }, showDreamupLogo && /*#__PURE__*/ React.createElement(DreamupIcon, {
        size: IconSize.LARGE,
        className: s['dreamup-logo']
    }), /*#__PURE__*/ React.createElement("div", {
        className: s['label']
    }, children)));
};
ImageRadioButton.displayName = 'ImageRadioButton';
export default ImageRadioButton;

//# sourceMappingURL=ImageRadioButton.js.map